import { faSatellite } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GENERIC_COMPONENTS } from 'components/AgentTemplateEditView/menu/genericComponents';
import { wGroupIndicesATPower } from 'components/AgentTemplateEditView/menu/power';
import A from 'components/general/A';
import ViewPortInlay from 'components/general/ViewPortInlay';
import { ISubsystem } from 'components/general/types/power';
import Wizard from 'components/general/wizards/Wizard';
import { useActiveEntities } from 'hooks';
import Routes from 'routes';
import LoadsSegment from './LoadsSegment';
import useStyles from './styles';

const SubsystemLoadingWizard = () => {
  const {
    branch: { id },
    subsystems,
  } = useActiveEntities();
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Wizard>
        {subsystems.map((s: ISubsystem) => (
          <LoadsSegment
            index={wGroupIndicesATPower.POWER_SSL.replaceAll('*', '') + `.${s.id}`}
            key={s.name}
            subsystem={s}
            onActionClick={() => undefined}
          />
        ))}
      </Wizard>
      <ViewPortInlay
        className={classes.subsystemHelperInlay}
        text={
          <>
            {'Add and manage subsystems in '}
            <span className={classes.subsystemHelperButton}>
              <FontAwesomeIcon icon={faSatellite} />
              <A href={`#${Routes.AGENT_TEMPLATE_EDIT(id, GENERIC_COMPONENTS)}`}>
                Generic Components
              </A>
            </span>
          </>
        }
      />
    </div>
  );
};
export default SubsystemLoadingWizard;
